import { render, staticRenderFns } from "./password.vue?vue&type=template&id=b2ec184a"
import script from "./password.vue?vue&type=script&lang=js"
export * from "./password.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2ec184a')) {
      api.createRecord('b2ec184a', component.options)
    } else {
      api.reload('b2ec184a', component.options)
    }
    module.hot.accept("./password.vue?vue&type=template&id=b2ec184a", function () {
      api.rerender('b2ec184a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/profile/password.vue"
export default component.exports